import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/functional_spaces/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listFunctionalSpaces, updateFunctionalSpace } from "../../../redux/actions/table/superadmin/functional_spaces";
import EditFunctionalSpaceForm from "../../../forms/superadmin/functional_spaces/EditFunctionalSpaceForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateFunctionalSpace(formData.id, _.omit(formData, ['id'])).then(() => {
                listFunctionalSpaces();

                this.props.readAction(formData.id);

                setNotification(__('superadmin.functional-spaces.flyout.properties.properties-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditFunctionalSpaceForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
